/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import Pill from "ui/kit/buttons/Pill";

interface Props {
    title: string;
    piecePlayMode: PiecePlayMode;
    selectMode: (mode: PiecePlayMode) => void;
    selectedMode: PiecePlayMode;
}

const PiecePlayModeSelectorButton: React.FC<Props> = ({title, piecePlayMode, selectMode, selectedMode}) => {

    const onPillClick = React.useCallback(() => {
        selectMode(piecePlayMode)
    }, [selectMode, piecePlayMode]);

    return (
        <Pill selected={piecePlayMode === selectedMode} title={title} onClick={onPillClick}/>
    );
}

export default PiecePlayModeSelectorButton